import { OPERATIONS_WHAT_WHO } from '@/data/operations';
import { ServiceWhatWho } from '../service/ServiceWhatWho';

export const WhatWeDoWhoFor = () => (
  <ServiceWhatWho
    data={OPERATIONS_WHAT_WHO}
    accent="#FFB800"
    accentDark="#9C7400"
    accentSoft="#FFF3CC"
    testidPrefix="operations"
  />
);
